import create from "zustand"

interface IprevPath {
  initialForum: boolean
  initialCategory: string
  initialQpl: boolean
  initialQuiz: boolean
  initialAnalyse: boolean
  isLoading: boolean
  reload: boolean
  reloadTrue: () => void
  reloadFalse: () => void
  loadingTrue: () => void
  loadingFalse: () => void
  fitnessState: () => void
  lifestyleState: () => void
  resetCategory: () => void
  nutritionState: () => void
  turnQplFalse: () => void
  turnQplTrue: () => void
  turnForumTrue: () => void
  turnForumFalse: () => void
  turnQuizTrue: () => void
  turnQuizFalse: () => void
  turnAnalyseFalse: () => void
  turnAnalyseTrue: () => void
}

const useStore = create<IprevPath>(set => ({
  initialForum: false,
  initialQpl: false,
  initialQuiz: false,
  initialAnalyse: false,
  initialCategory: "",
  isLoading: false,
  reload: false,
  reloadTrue: () => set({ reload: true }),
  reloadFalse: () => set({ reload: false }),
  loadingTrue: () => set({ isLoading: true }),
  loadingFalse: () => set({ isLoading: false }),
  fitnessState: () => set({ initialCategory: "Fitness" }),
  lifestyleState: () => set({ initialCategory: "Lifestyle" }),
  nutritionState: () => set({ initialCategory: "Nutrition" }),
  resetCategory: () => set({ initialCategory: "" }),
  turnForumTrue: () => set({ initialForum: true }),
  turnForumFalse: () => set({ initialForum: false }),
  turnQplTrue: () => set({ initialQpl: true }),
  turnQplFalse: () => set({ initialQpl: false }),
  turnQuizTrue: () => set({ initialQuiz: true }),
  turnQuizFalse: () => set({ initialQuiz: false }),
  turnAnalyseTrue: () => set({ initialAnalyse: true }),
  turnAnalyseFalse: () => set({ initialAnalyse: false }),
}))

export default useStore
